<script>
  import { createEventDispatcher, onMount, onDestroy } from "svelte";
  import { fly, fade } from "svelte/transition";
  import * as yup from "yup";
  import RestPilots from "../components/RestPilots.svelte";
  import MyModal from "../components/MyModal.svelte";
  import { ScrollingEnable, ScrollingDisable } from "../library/util.js";
  import { appSession } from "../stores/app.js";
  
  const dispatch = createEventDispatcher();

  let busy = false;
  let myModal;
  let restPilots;

  let form = {
    dirty: false,
    valid: true,
    submitted: false,

    data: {
      password: "",
      repeatpassword: ""
    },

    schema: yup.object().shape({
      password: yup
        .string()
        .test(
          "password",
          "8 characters minimum including one number & uppercase letter",
          value => {
            return ValidPassword(value);
          }
        )
        .required({ message: "Required" }),
      repeatpassword: yup
        .string()
        .test("repeatpassword", "Doesn't match", value => {
          return value === form.data.password;
        })
        .required({ message: "Required" })
    }),
    errors: null
  };

  onMount(() => {
    ScrollingDisable();
  });

  onDestroy(() => {
    ScrollingEnable();
  });

  function ValidPassword(password) {
    if (password.length < 8) return false;

    let oneNumeric = /[0-9]/g;
    if (!oneNumeric.test(password)) return false;

    let oneUppercase = /[A-Z]/g;
    if (!oneUppercase.test(password)) return false;

    return true;
  }

  function FieldChanged(field) {
    form.dirty = true;
  }

  function ValidateForm() {
    return new Promise(function(resolve, reject) {
      form.schema
        .validate(form.data, { abortEarly: false })
        .then(values => {
          form.valid = true;
          form.errors = {};
          resolve();
        })
        .catch(validationErrors => {
          form.valid = false;
          form.errors = {};

          for (let i = 0; i < validationErrors.inner.length; i++) {
            let error = validationErrors.inner[i];
            form.errors[error.path] = {
              type: error.type,
              message:
                typeof error.errors[0] == "object"
                  ? error.errors[0].message
                  : error.errors[0]
            };
          }

          reject("InvalidForm");
        });
    });
  }

  async function Change() {
    form.submitted = true;

    try {
      await ValidateForm();
      busy = true;

      let fields = {
        password: form.data.password
      };

      await restPilots.PutPilots($appSession.pilotId, fields);

      busy = false;
      dispatch("close", { changed: true });
    } catch (error) {
      busy = false;

      switch (error) {
        case "InvalidForm":
          break;
        case "BadRole":
        case "BadRealm":
          appSession.set({ authorisationToken: null, pilotid: null });
          break;
        case "NetworkError":
          myModal.showAlert(
            "Network error",
            "A network error occurred.<p> Check network connection and try again.</p>"
          );
          break;
        default:
          myModal.showAlert("Error", error);
          break;
      }
    }
  }
</script>

<div class="overlay-page-wrapper" transition:fly={{ y: 200, duration: 500 }}>
  <div class="overlay-page-header valign-wrapper">
    <div class="container">

      <div class="row">
        <div class="col s10 offset-s1">
          <h5 class="center-align">Change Password</h5>
        </div>
      </div>

    </div>
  </div>

  <div class="overlay-page-body">
    <div class="container">

      <div class="row">
        <div class="col s12 m6 offset-m3 xl4 offset-xl4">

          <div class="input-field">
            <input
              type="password"
              bind:value={form.data.password}
              on:change={() => FieldChanged('password')} />
            <label>New password</label>
            {#if form.errors && form.errors.password}
              <div class="helper-text red-text">
                {form.errors.password.message}
              </div>
            {/if}
          </div>

          <div class="input-field">
            <input
              type="password"
              bind:value={form.data.repeatpassword}
              on:change={() => FieldChanged('repeatpassword')} />
            <label>Repeat password</label>
            {#if form.errors && form.errors.repeatpassword}
              <div class="helper-text red-text">
                {form.errors.repeatpassword.message}
              </div>
            {/if}
          </div>

        </div>
      </div>

    </div>
  </div>

  <div class="overlay-page-footer">
    <div class="container">

      {#if busy}
        <div class="preloader-wrapper small active">
          <div class="spinner-layer spinner-green-only">
            <div class="circle-clipper left">
              <div class="circle" />
            </div>
            <div class="gap-patch">
              <div class="circle" />
            </div>
            <div class="circle-clipper right">
              <div class="circle" />
            </div>
          </div>
        </div>
      {/if}

      <div class="right">
        <button
          class="waves-effect btn-flat"
          on:click={() => {
            dispatch('close', {});
          }}>
          Cancel
        </button>
        <button
          class="btn waves-effect blue-grey"
          on:click={() => {
            Change();
          }}>
          Change
        </button>
      </div>
    </div>
  </div>

  <MyModal bind:this={myModal} />
  <RestPilots bind:this={restPilots} />
</div>
